document.addEventListener('DOMContentLoaded', () => {
    const editButtons = document.querySelectorAll('.btn-edit-type-driver');

    editButtons.forEach(btn => {
        btn.addEventListener('click', () => {
            // Ambil data dari atribut
            document.getElementById('id').value = btn.dataset.id;
            document.getElementById('kategory_id').value = btn.dataset.category;
            document.getElementById('city_price').value = btn.dataset.city;
            document.getElementById('out_city_price').value = btn.dataset.outcity;
            document.getElementById('border_price').value = btn.dataset.border;
            document.getElementById('meal_fee').value = btn.dataset.meal;
            document.getElementById('lodging_fee').value = btn.dataset.lodging;
            // Buka modal
            document.getElementById('modalDriverKategori').classList.remove('hidden');
        });
    });
});

export function openModalDriverKategori() {
    const modal = document.getElementById("modalDriverKategori");
    modal.classList.remove("hidden");
}

export function closeModalDriverKategori() {
    const modal = document.getElementById("modalDriverKategori");
    modal.classList.add("hidden");
}
